<template>
    <div class="overlay-loader">
        <div class="loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'my-preloader'
}
</script>

<style>
.overlay-loader {
    display: block;
    margin: 100px auto;
    width: 275px;
    height: 275px;
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 275px;
    height: 275px;
    animation-name: rotateAnim;
    -o-animation-name: rotateAnim;
    -ms-animation-name: rotateAnim;
    -webkit-animation-name: rotateAnim;
    -moz-animation-name: rotateAnim;
    animation-duration: 0.51s;
    -o-animation-duration: 0.51s;
    -ms-animation-duration: 0.51s;
    -webkit-animation-duration: 0.51s;
    -moz-animation-duration: 0.51s;
    animation-iteration-count: infinite;
    -o-animation-iteration-count: infinite;
    -ms-animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-timing-function: linear;
    -o-animation-timing-function: linear;
    -ms-animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
}

.loader div {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 3px solid rgba(229, 229, 229, 0.4);
    position: absolute;
    top: 6px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}

.loader div:nth-child(odd) {
    border-top: none;
    border-left: none;
}

.loader div:nth-child(even) {
    border-bottom: none;
    border-right: none;
}

.loader div:nth-child(2) {
    border-width: 6px;
    left: 0px;
    top: -11px;
    width: 33px;
    height: 33px;
}

.loader div:nth-child(3) {
    border-width: 6px;
    left: -3px;
    top: 8px;
    width: 50px;
    height: 50px;
}

.loader div:nth-child(4) {
    border-width: 8px;
    left: -3px;
    top: -11px;
    width: 66px;
    height: 66px;
}

.loader div:nth-child(5) {
    border-width: 8px;
    left: -3px;
    top: 11px;
    width: 88px;
    height: 88px;
}

.loader div:nth-child(6) {
    border-width: 11px;
    left: 0px;
    top: -11px;
    width: 110px;
    height: 110px;
}

.loader div:nth-child(7) {
    border-width: 11px;
    left: 0px;
    top: 17px;
    width: 138px;
    height: 138px;
}


@keyframes rotateAnim {
    from {
        transform: rotate(360deg);
    }

    to {
        transform: rotate(0deg);
    }
}

@-o-keyframes rotateAnim {
    from {
        -o-transform: rotate(360deg);
    }

    to {
        -o-transform: rotate(0deg);
    }
}

@-ms-keyframes rotateAnim {
    from {
        -ms-transform: rotate(360deg);
    }

    to {
        -ms-transform: rotate(0deg);
    }
}

@-webkit-keyframes rotateAnim {
    from {
        -webkit-transform: rotate(360deg);
    }

    to {
        -webkit-transform: rotate(0deg);
    }
}

@-moz-keyframes rotateAnim {
    from {
        -moz-transform: rotate(360deg);
    }

    to {
        -moz-transform: rotate(0deg);
    }
}
</style>